import React, { useState } from "react";
import { Input, Button } from "react-chat-elements";
import "react-chat-elements/dist/main.css";
import "../styles/newchat.css";
import axios from "axios";
import { useSelector } from "react-redux";

const NewChat = ({ onNewChat, title }) => {
  const [showForm, setShowForm] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [message, setMessage] = useState("");
  const { accessToken } = useSelector((state) => state?.auth);
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleCreateChat = async () => {
    if (!phoneNumber.trim() || !message.trim()) {
      alert("Phone number and message are required!");
      return;
    }

    try {
      await axios.post(apiUrl + "whatsapp/messages", {
        to: phoneNumber,
        text: message,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      setPhoneNumber("");
      setMessage("");
      onNewChat({ phoneNumber, message });
      setShowForm(false);
    } catch (error) {
      console.error("Error creating new chat:", error);
      console.error("Failed to create new chat. Please try again.");
    }
  };

  return (
    <div>
      <Button
        className={title === "Chats" ? "new-chat-btn" : "new-chats-btn"}
        text="+"
        backgroundColor="#075E54"
        color="white"
        onClick={() => setShowForm(!showForm)}
      />

      {showForm && (
        <div className="popup-overlay">
          <div className="popup-form">
            <h2>New Chat</h2>
            <Input
              placeholder="Enter phone number with country code"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
            <Input
              placeholder="Enter message"
              value={message}
              as="textarea"
              onChange={(e) => setMessage(e.target.value)}
            />
            <div className="d-flex justify-content-end align-items-center">
              <Button
                text="Send"
                className="mx-3 px-2"
                backgroundColor="#128C7E"
                color="white"
                onClick={handleCreateChat}
              />
              <Button
                text="Cancel"
                backgroundColor="grey"
                color="white"
                onClick={() => setShowForm(false)}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewChat;
